import * as Styled from './styles/actions-footer.styled'
import * as StyledAdmin from './styles/admin-sign-in-button.styled'
import {type AdminProps} from '../../login-page.types'
import {AdminSignInButton} from './admin-sign-in-button'
import useTypedSelector from '../../../../hooks/use-typed-selector'
import {gfcFlagSelector} from '../../../../store/state/config/selectors'
import {AdminSignInButtonGFC} from './admin-sign-in-button-gfc'
import {Navigate, useLocation} from 'react-router'
import {type JSX, useState} from 'react'

export function ActionsFooter(props: AdminProps): JSX.Element {
    const [shouldRedirectAdmin, setShouldRedirectAdmin] = useState(false)
    const location = useLocation()

    const appVersion = `V ${import.meta.env.VITE_MEDULLA_VERSION}${
        import.meta.env.VITE_BUILD_NUMBER ? `+${import.meta.env.VITE_BUILD_NUMBER}` : ''
    }`

    const gfcFlag = useTypedSelector(gfcFlagSelector)

    if (shouldRedirectAdmin) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        return <Navigate to="/adminLogin" state={location.state} replace />
    }

    if (props.admin) {
        return (
            <Styled.ActionsFooter>
                <AdminSignInButton />
            </Styled.ActionsFooter>
        )
    }

    return (
        <Styled.ActionsFooter>
            <span id="app-version">{appVersion}</span>
            {gfcFlag ? (
                <AdminSignInButtonGFC />
            ) : (
                <StyledAdmin.AdminSignInButton
                    id="admin-signin"
                    onClick={() => {
                        setShouldRedirectAdmin(true)
                    }}
                >
                    Admin Sign In
                </StyledAdmin.AdminSignInButton>
            )}
        </Styled.ActionsFooter>
    )
}
